import Auth from './AuthPage';
import Inventory from './InventoryPage';
import OnBoardSales from './OnBoardSalesPage';
import Orders from './OrdersPage';
import PaxCall from './PaxCallPage';
import Reports from './ReportsPage';
import Home from './HomePage';
import IfeHealth from './IfeHealthPage';

//More pages ?
export default {
    Auth,
    Home,
    IfeHealth,
    Inventory,
    OnBoardSales,
    Orders,
    PaxCall,
    Reports
}